import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useData } from '../../context/DataContext';

const Container = ({ children, className = "" }) => (
  <div className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>
);

const Footer = () => {
    const { categories } = useData();

    return (
        <footer className="bg-black">
            <Container className="py-12 sm:py-16">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
                    {/* LEFT HALF: Brand + Newsletter */}
                    <div className="lg:pr-8">
                        <Link 
                            to="/" 
                            className="text-2xl sm:text-3xl font-bold lowercase mb-6 inline-block hover:opacity-80 transition-opacity"
                            style={{ 
                                fontFamily: 'Poppins, sans-serif', 
                                fontWeight: 700,
                                color: '#ffffff'
                            }}
                        >
                            <span style={{ color: '#ffffff' }}>radiance</span><span style={{ color: '#ab3d22' }}>.</span>
                        </Link>
                        
                        <h3 className="text-xl sm:text-2xl font-bold text-white mb-3" style={{ fontFamily: 'Poppins, sans-serif' }}>
                            Your shortcut to smarter self-care.
                        </h3>
                        <p className="text-gray-400 mb-6 max-w-md leading-relaxed">
                            Honest beauty and wellness guidance, curated picks, and clear reasons why they're worth considering.
                        </p>
                        
                        <a 
                            href="http://eepurl.com/jpTPXQ"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 px-6 py-3 bg-[#ab3d22] hover:bg-[#8a2f1a] text-white font-semibold rounded-lg transition-colors"
                        >
                            Subscribe
                            <ChevronRight className="h-4 w-4" />
                        </a>
                        
                        <p className="text-gray-500 text-sm mt-4">
                            No noise. Just clarity.
                        </p>
                    </div>

                    {/* RIGHT HALF: Links */}
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 text-sm">
                        {/* Explore */}
                        <div>
                            <div className="font-semibold text-white mb-4">Explore</div>
                            <ul className="space-y-2.5 text-gray-400">
                                {categories && categories.length > 0 ? (
                                    categories.slice(0, 6).map(category => (
                                        <li key={category._id}>
                                            <Link to={`/category/${category.slug}`} className="hover:text-white transition-colors">
                                                {category.name}
                                            </Link>
                                        </li>
                                    ))
                                ) : (
                                    <>
                                        <li><Link to="/category/skincare" className="hover:text-white transition-colors">Skincare</Link></li>
                                        <li><Link to="/category/hair" className="hover:text-white transition-colors">Hair</Link></li>
                                        <li><Link to="/category/makeup" className="hover:text-white transition-colors">Makeup</Link></li>
                                        <li><Link to="/category/body" className="hover:text-white transition-colors">Body</Link></li>
                                        <li><Link to="/category/wellness" className="hover:text-white transition-colors">Wellness</Link></li>
                                        <li><Link to="/category/health" className="hover:text-white transition-colors">Health</Link></li>
                                    </>
                                )}
                                <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
                            </ul>
                        </div>

                        {/* Company */}
                        <div>
                            <div className="font-semibold text-white mb-4">Company</div>
                            <ul className="space-y-2.5 text-gray-400">
                                <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
                                <li><Link to="/editorial-standards" className="hover:text-white transition-colors">Editorial Standards</Link></li>
                                <li><Link to="/affiliate-disclosure" className="hover:text-white transition-colors">Affiliate Disclosure</Link></li>
                                <li><Link to="/advertise" className="hover:text-white transition-colors">Advertise</Link></li>
                                <li><Link to="/terms" className="hover:text-white transition-colors">Terms</Link></li>
                                <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link></li>
                                <li><Link to="/cookies" className="hover:text-white transition-colors">Cookies</Link></li>
                            </ul>
                        </div>

                        {/* Connect */}
                        <div>
                            <div className="font-semibold text-white mb-4">Connect</div>
                            <ul className="space-y-2.5 text-gray-400">
                                <li><Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                {/* Bottom row */}
                <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-500 text-sm">
                    <p>&copy; 2025 Radiance. All rights reserved.</p>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;
